import React, { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

import Icon from "./icons";
import Label from "./elements/form/fromLabel";
interface SignatureProps {
  canClear?: boolean;
  className?: string;
  isHideLabel?: boolean;
  displaySignature?: null | string;
  onComplete: (data: string, datafile: File) => void;
  onClear?: () => void;
}

const Signaturepad: React.FC<SignatureProps> = ({
  canClear = true,
  className = ``,
  onClear = () => {},
  onComplete = (data: string, datafile: File) => {},
  isHideLabel = false,
  displaySignature = null
}) => {

  const hasSignRendered = useRef<boolean>(false);  

  const sigCanvas = useRef<SignatureCanvas>(null);
  const signWrapper = useRef<HTMLDivElement>(null);
  const [signapply, setSignApply] = useState<boolean>(false);
  const [signature, setSignature] = useState<any>(null);

  const base64ToFile = (base64Data: string, filename: string): File => {
    const arr = base64Data.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  useEffect(() => {
    if (displaySignature) {
      setSignature(displaySignature);
      setSignApply(true);      
    }
  }, []);

  return (
    <div className={`my-6 ${className}`}>
      { !isHideLabel && <Label text={`Signature`} required={true} info={``} /> }
      <div className={ `flex items-center justify-start ${!isHideLabel? `mt-3`: ``}` }>
        <div style={{ position: "relative", background: `#fff` }} className={ `${!isHideLabel? `mt-3`: ``}` } ref={signWrapper}>
          {signapply? (
            <div className={`flex justify-end items-center gap-3`} style={{ background: `#eee`, padding: `10px 5px`, borderRadius: `3px 3px 0 0` }}>
              <a className={`flex items-center gap-1`} style={{ color: `#fff`, padding: `3px 7px 3px 5px`, background: `#2b5a2e`, borderRadius: `3px` }} onClick={() => {
                  if (sigCanvas.current) {
                      setSignApply(false);
                      sigCanvas.current.clear();
                  }
                  onClear();                
                }}
              >
                <Icon name={`restart`} /> Re-start
              </a>            
            </div>
          ): (
            <div className={`flex justify-end items-center gap-3`} style={{ background: `#2b5a2e`, padding: `10px 5px`, borderRadius: `3px 3px 0 0` }}>
              <a className={`flex items-center gap-1`} style={{ color: `#000`, padding: `3px 7px 3px 5px`, background: `linear-gradient(0deg, #eee, #f1f1f1, #eee)`, borderRadius: `3px` }} onClick={() => {
                  if (sigCanvas.current) {
                    const dataURL = sigCanvas.current.toDataURL("image/png");
                    if (dataURL) {
                      const signaturefile = base64ToFile(dataURL, "signature.png");
                      setSignature(dataURL);                      
                      setSignApply(true);
                      onComplete(dataURL, signaturefile);                      
                      sigCanvas.current.clear();
                    }
                  }
                }}
              >
                <Icon name={`tick`} /> Apply
              </a>
              {canClear && (
                  <a className={`flex items-center gap-1`} style={{ color: `#000`, padding: `3px 7px 3px 5px`, background: `linear-gradient(0deg, #eee, #f1f1f1, #eee)`, borderRadius: `3px` }} onClick={() => {                      
                      if (sigCanvas.current) {
                        sigCanvas.current.clear();
                      }
                      onClear();
                  }}
                  >
                  <Icon name={`cross`} /> Clear
                  </a>
              )}
            </div>
          )}
          <div className={ `relative` }>
            {signapply && signature && (
              <img src={ signature } style={{ position: `absolute`, inset: 0, width: `100%`, objectFit: `contain`, objectPosition: `center` }} />
            )}
            <SignatureCanvas penColor="black" canvasProps={{ width: 673, height: 150, className: "border rounded-md" }} ref={sigCanvas} /> 
          </div>                   
        </div>
      </div>
    </div>
  );
};

export default Signaturepad;
